import React, { useEffect, useState } from 'react';
import { Row, Modal, ModalBody } from 'reactstrap';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { isMobileOnly } from 'react-device-detect';
import Spinner from '../../shared/Spinner';
import Constants from '../../../Constants';
import { currentUser } from '../../../services/CurrentUser';

var unique = require('array-unique');
function EirCustomiseBundleTV(props) {
    const [isLoading, setIsLoading] = useState(true);
    //check if user lands here after selecting a tv bundle
    const isTVSelected = (localStorage.getItem("ls-eir_clicked_context") === "tv") ? true : false;
    const [spinnerVisible, setSpinnerVisible] = useState(false);
    const tvPlansFromLS = JSON.parse(localStorage.getItem("eir_be_data")).tvPlans;
    const [tvAfterPrice, setTvAfterPrice] = useState(null); // fetch the after price to be shown in the tv tile 
    // let channelListFromBE, whatsInBoxList;
    const [displayModel, setdisplayModel] = useState(false);
    const [eirTvLogo, setEirTvLogo] = useState('/.galleries/customise-page/eir-tv-logo-blackfont.png');
    const [eirTvExtraLogo, setEirTvExtraLogo] = useState('/.galleries/customise-page/eir-tv-extra-logo-whitefont.png');
    const toggleModel = () => {
        setdisplayModel(false);
    }
    const viewChannels = () => {
        setdisplayModel(true);
    }
    const handleTabSelect = (key) => {
        if (key == 'eir TV') {
            setEirTvLogo('/.galleries/customise-page/eir-tv-logo-blackfont.png');
            setEirTvExtraLogo('/.galleries/customise-page/eir-tv-extra-logo-whitefont.png');
        }
        else {
            setEirTvLogo('/.galleries/customise-page/eir-tv-logo-whitefont.png');
            setEirTvExtraLogo('/.galleries/customise-page/eir-tv-extra-logo-blackfont.png');
        }
    }
    /*Updating Cart quantity */
    refreshCartNumber = function () {
        var cartQuantity = $('.cart-quantity');
        if (cartQuantity) {
            if ($.cookie('eir_current_order')) {
                try {
                    $.ajax({
                        url: '/store/api/cart',
                        success: function (response) {
                            if (response && response.numberOfProducts) {
                                cartQuantity.html(response.numberOfProducts);
                                cartQuantity.show();
                            }
                        }
                    });
                }
                catch (err) {
                    console.log("Cart Number not updating");
                }
            }
        }
    }



    $("#view-channels-3").on("click", function (e) {
        viewChannels();
    });
    $("#view-channels-2").on("click", function (e) {
        viewChannels();
    });
    $("#view-channels-1").on("click", function (e) {
        viewChannels();
    });


    let eirTvChannels = []
    let eirTvExtraChannels = []
    /* ************************ TV Channels popup - start ************************ */
    let getTvChannels;
    //get the list of channels from the opencms component
    for (let i = 0; i < window.components.length; i++) {
        if (window.components[i].type == "eir-customise-tv-channels") {
            getTvChannels = window.components[i].cmsContent.tvlogos
        }
    }
    //sort the channels based on the eirtv, eirtv extra and push them to respective arrays
    for (var i in getTvChannels) {
        if (getTvChannels[i].image.indexOf("/eirtvplus") > 0) {
            eirTvChannels.push(getTvChannels[i]);
        }
        else if (getTvChannels[i].image.indexOf("/eirtvextra") > 0) {
            eirTvExtraChannels.push(getTvChannels[i]);
        }
    }

    if (getTvChannels[i].image.indexOf("/eirtvextra") > 0) {
        eirTvExtraChannels.push(getTvChannels[i]);
    }


    var getUniqueGenreEirTv = [];
    var getUniqueGenreEirExtraTv = [];
    for (var i = 0; i < eirTvChannels.length; i++) {
        getUniqueGenreEirTv.push(eirTvChannels[i].category)
    }
    for (var i = 0; i < eirTvExtraChannels.length; i++) {
        getUniqueGenreEirExtraTv.push(eirTvExtraChannels[i].category)
    }
    var printEirTvChannels = "";
    var printEirTvExtraChannels = "";
    // add html elements to render the channels based on the selected tab in the overlay
    setTimeout(() => {
        for (var i = 0; i < unique(getUniqueGenreEirTv).length; i++) {
            printEirTvChannels += '<div><div class=" mb-2 col-12"><h4>' + getUniqueGenreEirTv[i] + '</h4><div class="aaa">';
            for (var j = 0; j < eirTvChannels.length; j++) {
                if (getUniqueGenreEirTv[i] === eirTvChannels[j].category) {
                    printEirTvChannels += "<img class='channel-img' alt='" + eirTvChannels[j].alt + "' src='" + eirTvChannels[j].image + "' />"
                }
            }
            printEirTvChannels += "</div></div>"
        }
        $("#eirTvChannels-ctr").html(printEirTvChannels);

        for (var i = 0; i < unique(getUniqueGenreEirExtraTv).length; i++) {
            printEirTvExtraChannels += '<div><div class=" mb-2"><h4>' + getUniqueGenreEirExtraTv[i] + '</h4>';
            for (var j = 0; j < eirTvExtraChannels.length; j++) {
                if (getUniqueGenreEirExtraTv[i] === eirTvExtraChannels[j].category) {
                    printEirTvExtraChannels += "<img class='channel-img' alt='" + eirTvExtraChannels[j].alt + "' src='" + eirTvExtraChannels[j].image + "' />"
                }
            }
            printEirTvExtraChannels += "</div>"
        }
        $("#eirTvExtraChannels-ctr").html(printEirTvExtraChannels);
    }, 200);

    useEffect(() => {
        // if (JSON.parse(localStorage.getItem("eir_be_data")).channelPacks) {// if TV is available
        //     setTvAfterPrice(JSON.parse(localStorage.getItem("eir_be_data")).channelPacks[0].basePrice);
        // }
        // else
        //     setTvAfterPrice(null);
        if (tvPlansFromLS) {
            for (var i = 0; i < tvPlansFromLS.length; i++) {
                if (tvPlansFromLS[i].r6Key === "RT_IPTV_CLOUD_STANDARD_2023") {
                    var getListHTML = tvPlansFromLS[i].detailsHtml.split("</ul>");
                    $(".channelListFromBE").html(getListHTML[0]);
                    $(".whatsInBoxList").html(getListHTML[1]);
                    $(".promo-price").html(tvPlansFromLS[i].promoHtml.split("|")[0].substring(tvPlansFromLS[i].promoHtml.split("|")[0].indexOf('=') + 1));
                    $(".promo-duration").html(tvPlansFromLS[i].promoHtml.split("|")[2].substring(tvPlansFromLS[i].promoHtml.split("|")[2].indexOf('=') + 1));
                    setTvAfterPrice(tvPlansFromLS[i].promoHtml.split("|")[1].substring(tvPlansFromLS[i].promoHtml.split("|")[1].indexOf('=') + 1));
                }
            }
        }
        //*********** Call outs for add ons ************/

        // if ($(".tv-addons .config-card__card").length > 0) {
        //     setTimeout(() => {
        //         for (var i = 0; i <= ($(".tv-addons .config-card__card").length - 1); i++) {
        //             //condition to check if it is text or timer should come
        //             if (JSON.parse(localStorage.getItem("eir_be_data")).tvAddOns[i].id == "475a4b84-de8c-11e9-b2a6-005056bb57df") {
        //                 var callOutText = document.createElement('div');
        //                 callOutText.classList.add('Call-out-promo-text');
        //                 $(".tv-addons .config-card__card")[i].prepend(callOutText);
        //                 $(".Call-out-promo-text").text("  GET 1 MONTH FREE  ");
        //             }
        //             else {
        //                 var callOutTimer = document.createElement('div');
        //                 var days = "xx";
        //                 var hours = "xx ";
        //                 var min = "xx ";
        //                 var sec = "xx ";
        //                 callOutTimer.classList.add('Call-out-promo-timer');
        //                 $(".tv-addons .config-card__card")[i].prepend(callOutTimer);
        //                 $('.Call-out-promo-timer').append("<span class='limited-time-offer'>" + "Limited time offer!  " + '</span>');
        //                 $('.Call-out-promo-timer').append("<span class='timer-outer-div'></span>");
        //                 $('.timer-outer-div').append("<span class='timer-text'>" + "<span class='timer-time'>" + days + "</span>" + " days " + "</span>");
        //                 $('.timer-outer-div').append("<span class='timer-text'>" + "<span class='timer-time'>" + hours + "</span>" + " hrs " + "</span>");
        //                 $('.timer-outer-div').append("<span class='timer-text'>" + "<span class='timer-time'>" + min + "</span>" + " mins " + "</span>");
        //                 $('.timer-outer-div').append("<span class='timer-text'>" + "<span class='timer-time'>" + sec + "</span>" + " secs " + "</span>");
        //             }
        //         }
        //     }, 7000);
        // }


        var getBundle = JSON.parse(localStorage.getItem("eir_be_data"));
        if (getBundle.order.bundle.tv != undefined || getBundle.order.bundle.tv != null) {
            $(".tv-details-ctr  ").addClass("d-none");                      // hiding tv panel if 3P_TV is selected
            $(".tvPack").removeClass("d-none");

        }
        $("input[type=radio]:checked").parent().addClass("labelSelected");
        setTimeout(() => {
            setIsLoading(false);
            $(".tv-config").removeClass("d-none")
        }, 7000);

        $("#noanim-tab-example-tab-eir TV Extra").on("click", function (e) {
            alert("==eirtv clicked");
        })

        $(".select-tv").on("click", function (e) {
            $(this).addClass("button--disabled");
            setSpinnerVisible(true);
            var tvTile = $(".tv-details-ctr .config-card__card ");
            var tvTileImage = $(".tv-step-parent .tv-details-ctr .tv-tile-image img")
            setTimeout(() => {
                if ($(tvTile).hasClass("selected")) {
                    config.tv.remove();
                    setTimeout(() => {
                        $(tvTile).removeClass("selected");
                        $(tvTileImage).removeClass("pb-2px");
                        $(".tvPack").addClass("d-none");
                        $(this).text("Select");
                        setSpinnerVisible(false);
                        $(this).removeClass("button--disabled");
                        $(".ap-config__multiroom-ctr .card").removeClass("multiRoom-selected");

                    }, 4000);
                } else {
                    config.tv.add();

                    setTimeout(() => {
                        //console.log("adding TV timeout");
                        $(tvTile).addClass("selected");
                        $(this).text("Selected");
                        $(tvTileImage).addClass("pb-2px");
                        $(".tvPack").removeClass("d-none");
                        setSpinnerVisible(false);
                        $(this).removeClass("button--disabled");

                    }, 5000);

                }
            }, 1200);
        })
    }, []);





    return (
        <div class="tv-main">
            <div className="ap-config__accordion__bellow tv-config tv-step-parent d-none">
                <div className="ap-config__accordion__bellow__upsell show">
                    <h3 className="ap-config__accordion__bellow__upsell__heading">
                        Why not add...
                    </h3>
                    <div className="ap-config__accordion__bellow__upsell__title icon-combo icon-combo--inline icon-combo--25h-25w">
                        <div className="icon-tv_grey-dark icon-combo__icon"></div>
                        <div className="inline text-bottom">TV</div>
                    </div>
                    <p className="ap-config__accordion__bellow__upsell__description">
                        Build your TV package around you
                    </p>
                </div>
                <p className="ap-config__accordion__bellow__upsell__button d-none">
                    <a href="" className="button button--secondary fill-pink add-tv gtm-normal-cta">Add TV</a>
                </p>

                <div className="ap-config__accordion__bellow__header__text d-none">
                    <p className="ap-config__accordion__bellow__header__description">Build your TV package around you</p>
                    <div id="testrem">REMOVE</div>
                    <a href="#" className="ap-config__accordion__bellow__header__link gtm-linkclick-cta" data-tooltip="false" data-tooltip-type="interactive" data-tooltip-position="top" data-tooltip-title="Do you want to remove TV?" data-tooltip-body="By removing this product from your shopping cart your new bundle total will be â‚¬00.00." data-tooltip-button-one-text="Yes, Remove" data-tooltip-button-one-event="ap-config-remove-tv" data-tooltip-button-two-text="No, Don't Remove" data-tooltip-button-two-event="close-tooltip">Remove</a>
                    <p className="ap-config__accordion__bellow__header__error hide">Item cannot be removed</p>
                </div>
                <div className="ap-config__accordion__bellow__body tv-plan ">
                    {/* <div className="row d-none">
                        <div className="column large-12 small-12">
                            <div className="alert fill-blue">
                                <div className="row">
                                    <div className="alert__text-column">
                                        <p className="alert__header">We Need Your Attention!</p>
                                        <p className="alert__subtext">You may have made some changes to your original bundle. If you would like to revert click the button.</p>
                                    </div>
                                    <div className="alert__button-column">
                                        <a href="" className="button button--small button--secondary fill-white text-black--light gtm-normal-cta">Update Cart</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="tv-details-ctr">
                        <h3 className="ap-config__accordion__bellow__sub-heading-one">Add eir tv</h3>
                        <div className="config-card">
                            <div className="config-card__card config-card__card--size-6 config-card-heading config-card-link config-card-subtext">
                                <div className="config-card__inner">
                                    <div className="config-card__promo">
                                        <p className="config-card__promo__heading">
                                            {/* <%--Save 20% on your first 3 months!--%> */}
                                        </p>
                                    </div>
                                    <div className="config-card__disabled">
                                        <p className="config-card__disabled__heading">Incompatible with chosen bundle!</p>
                                    </div>
                                    <div className="config-card__base col-12">
                                        <div className="col-5 inline-block tv-tile-image">
                                            <img src="/.galleries/customise-page/eirTv.png" id="addon-tv-img-' + counter + '" alt="' + card.heading.content + '" />
                                        </div>
                                        <div className={(isMobileOnly ? "col-12" : "col-7") + " " + "inline-block tv-tile-copy-ctr "}>
                                            <div className={(isMobileOnly ? "col-12" : "col-5") + " " + "inline-block pl-0 pr-1 tv-tile-copy-col"}>

                                                <p className="config-card__subtext">What's included:</p>

                                                <div className="config-card__price euro per-month"><p className="config-card__price__strike"><strike></strike></p>5</div>

                                                {/* <a href="" onClick={viewChannels} className="config-card__link js-channels-popup-eir-tv-plus">View all channels</a>                                                */}
                                                <a className="config-card__button select"></a>
                                                <div className="channelListFromBE"></div>
                                            </div>

                                            <div className={(isMobileOnly ? "col-12" : "col-7") + " " + "inline-block tv-tile-copy-col pl-4 pr-0"}>
                                                <p className="config-card__subtext">What's in the box</p>
                                                <div className="whatsInBoxList"></div>
                                                <div className="col-12 inline-block text-bottom tv-price-section pl-0">
                                                    <div className="col-5 inline-block tv-tile-price-details nowrap pl-0">
                                                        <span className="tv-bundle-price nowrap "><span className="bold">&euro;<span className="promo-price"></span></span> a month<br/>for the duration of the contract</span><br />
                                                        <span className="tv-bundle-afterPrice nowrap "> &euro;{tvAfterPrice ? tvAfterPrice : ''} thereafter </span>
                                                    </div>
                                                    <div className="col-7 inline-block pr-0">
                                                        <p className="ap-config__accordion__bellow__upsell__button col-12 tv-tile-select-button text-right nowrap pr-0">
                                                            <a href="" className="button button--secondary select-tv gtm-normal-cta">Select
                                                            </a>
                                                            <span className="tick-icon"></span>
                                                            {spinnerVisible &&
                                                                <Spinner />
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* TV channels popup */}
                    <Modal className="modalDialog tv-channels-popup" centered={true} isOpen={displayModel} toggle={toggleModel} >
                        <ModalBody className={"modalContent " + ((isMobileOnly) ? 'p-4' : '')}>
                            <img onClick={toggleModel} src={'/.galleries/eir/icons/plus-circle-hover.png'} alt="Close" className="phonedetails-close-icon" />

                            <Tabs defaultActiveKey="eir TV" id="noanim-tab-example" onSelect={handleTabSelect}>
                                <Tab eventKey="eir TV"
                                    title={<img src={eirTvLogo} id="eirTvTab" alt="eir TV"
                                        className="tv-channel-popup-nav-logo" />}>

                                    <Row id="eirTvChannels-ctr" className="customise-page-channels-ctr">
                                    </Row>

                                </Tab>
                                <Tab eventKey="eir TV Extra"
                                    title={<img src={eirTvExtraLogo} id="eirTvExtraTab"
                                        alt="eir TV Extra" className="tv-channel-popup-navitem-logo" />}>
                                    <Row id="eirTvExtraChannels-ctr" className="customise-page-channels-ctr">

                                    </Row>
                                </Tab>
                            </Tabs>
                        </ModalBody>
                    </Modal>




                    <div className="tvPack d-none">
                        <h3 className="ap-config__accordion__bellow__sub-heading">Personalise your TV pack</h3>
                        <div className="config-card tv-addons tv-addons-details-ctr">
                            <div className="config-card__card config-card__card--size-6 config-card-heading config-card-price config-card-price-strike config-card-link config-card-button config-card-promo">
                                <div className="config-card__inner">
                                    <div className="config-card__disabled">
                                        <p className="config-card__disabled__heading">Incompatible with chosen bundle!</p>
                                    </div>
                                    <div className="config-card__base">
                                        <p className="config-card__heading">
                                            {/* <%--eVision Experience Pack--%> */}
                                        </p>
                                        <p className="config-card__subtext">
                                            {/* <%--Promotional Description can come here.--%> */}
                                        </p>
                                        <div className="config-card__price euro per-month">
                                        </div>
                                        <a href="#" className="config-card__link js-ajax-lightbox gtm-linkclick-cta" data-effect="mfp-zoom-in" aria-haspopup="true">View Channels</a>
                                        <a className="config-card__button add"></a>
                                        <a className="config-card__button add"></a>
                                    </div>
                                    <div className="config-card__disabled"></div>
                                </div>
                            </div>
                            <div className="config-card__card config-card__card--size-6 config-card-heading config-card-price config-card-price-strike config-card-link config-card-button config-card-promo">
                                <div className="config-card__inner">
                                    <div className="config-card__promo">
                                        <p className="config-card__promo__heading">
                                            {/* <%--Save 20% on your first 3 months!--%> */}
                                        </p>
                                    </div>
                                    <div className="config-card__disabled">
                                        <p className="config-card__disabled__heading"><span>Incompatible with chosen bundle!</span><span data-incompatible-selected="IPTV:SKYMOVIES_PACK">It is cheaper to buy Sky Cinema and Sky Sports together</span><span data-incompatible-selected="IPTV:SKYSPORTS_SKYMOVIES_PACK">Already included</span></p>
                                    </div>
                                    <div className="config-card__base">
                                        <p className="config-card__heading">
                                            {/* <%--Sky Sports--%> */}
                                        </p>
                                        <p className="config-card__subtext">
                                            {/* <%--Promotional Description can come here.--%> */}
                                        </p>
                                        <div className="config-card__price euro per-month">
                                            {/* <%--<p className="config-card__price__strike"><strike>12</strike></p>8--%> */}
                                        </div>
                                        <a href="#" className="config-card__link js-ajax-lightbox gtm-linkclick-cta" data-effect="mfp-zoom-in" aria-haspopup="true">View Channels</a>
                                        <a className="config-card__button add"></a>
                                    </div>
                                </div>
                            </div>
                            <div className="config-card__card config-card__card--size-6 config-card-heading config-card-price config-card-link config-card-button">
                                <div className="config-card__inner">
                                    <div className="config-card__promo">
                                        <p className="config-card__promo__heading">
                                            {/* <%--Save 20% on your first 3 months!--%> */}
                                        </p>
                                    </div>
                                    <div className="config-card__disabled">
                                        <p className="config-card__disabled__heading"><span>Incompatible with chosen bundle!</span><span data-incompatible-selected="IPTV:SKY_SPORTS_CHANNEL_PACKAGE">It is cheaper to buy Sky Cinema and Sky Sports together</span><span data-incompatible-selected="IPTV:SKYSPORTS_SKYMOVIES_PACK">Already included</span></p>
                                    </div>
                                    <div className="config-card__base">
                                        <p className="config-card__heading">
                                            {/* <%--Sky Cinema--%> */}
                                        </p>
                                        <p className="config-card__subtext">
                                            {/* <%--Promotional Description can come here.--%> */}
                                        </p>
                                        <div className="config-card__price euro per-month">
                                            {/* <%--<p className="config-card__price__strike"><strike></strike></p>24--%> */}
                                        </div>
                                        <a href="#" className="config-card__link js-ajax-lightbox gtm-linkclick-cta" data-effect="mfp-zoom-in" aria-haspopup="true">View Channels</a>
                                        <a className="config-card__button add"></a>
                                    </div>
                                </div>
                            </div>
                            <div className="config-card__card config-card__card--size-6 config-card-heading config-card-price config-card-link config-card-button">
                                <div className="config-card__inner">
                                    <div className="config-card__promo">
                                        <p className="config-card__promo__heading">Save 20% on your first 3 months!</p>
                                    </div>
                                    <div className="config-card__disabled">
                                        <p className="config-card__disabled__heading">Incompatible with chosen bundle!</p>
                                    </div>
                                    <div className="config-card__base">
                                        <p className="config-card__heading">
                                            {/* <%--HD Add-on Pack--%> */}
                                        </p>
                                        <p className="config-card__subtext">
                                            {/* <%--Promotional Description can come here.--%> */}
                                        </p>
                                        <div className="config-card__price euro per-month">
                                            {/* <%--<p className="config-card__price__strike"><strike></strike></p>8--%> */}
                                        </div>
                                        <a href="#" className="config-card__link js-ajax-lightbox gtm-linkclick-cta" data-effect="mfp-zoom-in" aria-haspopup="true">View Channels</a>
                                        <a className="config-card__button add"></a>
                                    </div>
                                </div>
                            </div>
                            <div className="config-card__card config-card__card--size-6 config-card-heading config-card-price config-card-link config-card-button config-card-disabled">
                                <div className="config-card__inner">
                                    <div className="config-card__promo">
                                        <p className="config-card__promo__heading">
                                            Save 20% on your first 3 months!
                                        </p>
                                    </div>
                                    <div className="config-card__disabled">
                                        <p className="config-card__disabled__heading">Incompatible with chosen bundle!</p>
                                    </div>
                                    <div className="config-card__base">
                                        <p className="config-card__heading">
                                            {/* <%--Sky Sports & Sky Cinema--%> */}
                                        </p>
                                        <p className="config-card__subtext">
                                            {/* <%--Promotional Description can come here.--%> */}
                                        </p>
                                        <div className="config-card__price euro per-month">
                                            {/* <%--<p className="config-card__price__strike"><strike></strike></p>46--%> */}
                                        </div>
                                        <a href="#" className="config-card__link js-ajax-lightbox gtm-linkclick-cta" data-effect="mfp-zoom-in" aria-haspopup="true">View Channels</a>
                                        <a className="config-card__button add"></a>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="ap-config__multiroom-ctr col-12">
                            <div className=" ap-config__multiroom-card card ">
                                <div className={(isMobileOnly ? "col-5" : "col-3") + " " + "tv-tile-multiroom-image-ctr"}>
                                    <img src="/.galleries/business/3-6-Column/eir-small-business.jpg" alt="multiroom" />
                                </div>
                                <div className="ap-config__multiroom__content col-5">
                                    <p className="ap-config__multiroom__content__heading">Multiroom Viewing</p>
                                    <p className="ap-config__multiroom__content__subtext">Enjoy multiroom viewing anywhere in the house. Apple 4K TV box included.</p>
                                </div>
                                <div class="ap-config__multiroom__content__price col-2 config-card__price per-month">
                                    <p class="config-card__price__strike">
                                        <strike></strike></p>+€9.99<span class="per-month-per"> a month </span>
                                    <span class="per-month-extra">per extra room</span>
                                </div>
                                <div className="ap-config__multiroom__selection col-2">
                                    <form>
                                        <fieldset className="fieldset__radio">
                                            <legend className="form-legend--hidden">Multiroom Viewing</legend>
                                            <span className="radio-options">
                                                <label htmlFor="zeroMultiRoom">
                                                    <input checked="checked" type="radio" value="0" id="zeroMultiRoom" name="multiroom-number" />
                                                    <span>0</span>
                                                </label>
                                                <label htmlFor="oneMultiRoom">
                                                    <input type="radio" id="oneMultiRoom" value="1" name="multiroom-number" />
                                                    <span>1</span>
                                                </label>
                                                <label htmlFor="twoMultiRoom">
                                                    <input type="radio" id="twoMultiRoom" value="2" name="multiroom-number" />
                                                    <span>2</span>
                                                </label>
                                            </span>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ap-config__accordion__bellow__border"></div>
            </div>
        </div >
    );
}
export default EirCustomiseBundleTV;